<template>
	<b-modal
		v-model="dialog"
		:title="title"
		:ok-only="okOnly"
		:header-bg-variant="options.background"
		:header-text-variant="options.text"
		@ok="agree"
		@cancel="disagree"
		@close="disagree"
	>
		<p
			v-show="!!message"
			class="my-4"
			v-html="message"
		></p>

	</b-modal>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */

export default {
	data: () => ({
		dialog: false,
		resolve: null,
		reject: null,
		message: null,
		title: null,
		okOnly: false,
		options: {
			text : "dark",
			background : "light"
		}
	}),
	methods: {
		open(title, message, okOnly, options) {
			this.dialog = true;
			this.title = title;
			this.message = message;
			
			if (options) {
				this.options = options;
			} else {
				this.options = {
					text : "dark",
					background : "light"
				};
			}


			if (okOnly) {
				this.okOnly = true;
			}
			return new Promise((resolve, reject) => {
				this.resolve = resolve;
				this.reject = reject;
			});
		},
		agree() {
			this.resolve(true);
			this.dialog = false;
		},
		disagree() {
			this.resolve(false);
			this.dialog = false;
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/partials/confirm.vue